import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StepDescriptionWrapper } from './subcomponents';
const Step = forwardRef(({ stepData, dataCy, placement }, ref) => {
    return (_jsx(StepDescriptionWrapper, Object.assign({ "data-cy": dataCy, "$placement": placement, ref: ref }, { children: stepData })));
});
export default Step;
//# sourceMappingURL=Step.js.map